<h2 mat-dialog-title>{{ 'INTL_DETAIL' | translate }}</h2>
<mat-dialog-content>
  <p class="file-name">
    <strong>{{ 'INTL_NAME' | translate }}:</strong> {{ data.name }}
  </p>
  <p><strong>Type:</strong> {{ data.type }}</p>
  <p *ngIf="data.modifiedBy">
    <strong>{{ 'INTL_MODIFIED_BY' | translate }}:</strong> {{ data.modifiedBy?.fullName }}
  </p>
  <p *ngIf="data.modifiedAt">
    <strong>{{ 'INTL_MODIFIED_AT' | translate }}:</strong> {{ data.modifiedAt | date }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
